/**
 * Redux reducer for the user interface.
 * @module redux/reducers/userInterface
 */

import { THEME_CHANGED } from "../actions/userInterface";
import Themes from "../themes/";

const initialState = {
  theme: Themes.standard,
  themeName: "standard"
};

const ACTION_HANDLERS = {
  [THEME_CHANGED]: (state, action) => ({
    theme: action.payload.theme,
    themeName: action.payload.themeName
  })
};

export default function userInterface(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/userInterface.js